import { NgModule } from "@angular/core";
import { BulkActivationComponent } from "./bulk-activation.component";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/shared/material.module";
import { DndDirective } from "./dnd.directive";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { BulkActivationTableComponent } from './bulk-activation-table/bulk-activation-table.component';
import { BulkActivationConfirmComponent } from './bulk-activation-confirm/bulk-activation-confirm.component';
import { BulkCsvFormComponent } from './bulk-csv-form/bulk-csv-form.component';
import { HttpClientModule } from "@angular/common/http";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatCardModule } from "@angular/material/card";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
    declarations: [
        DndDirective,
        BulkActivationComponent,
        BulkActivationTableComponent,
        BulkActivationConfirmComponent,
        BulkCsvFormComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        MaterialModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatButtonModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCardModule,
        MatTableModule,
        MatIconModule
    ],
    exports: [BulkCsvFormComponent]
})

export class BulkActivationModule { }